import React from 'react';

const HeroSection = () => {
    const handleScroll = () => {
      const el = document.getElementById('explore');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    };
    return (
    <section className="relative h-screen min-h-[500px] sm:min-h-[600px]">
            {/* Use inline style so CRA serves public image correctly at /images/... */}
            <div
                className="hero absolute inset-0 bg-cover bg-center bg-no-repeat"
                style={{ backgroundImage: "url(/images/restaurant-bg.png)" }}
                role="img"
                aria-label="Casa Gatchalian bar interior with hanging lights"
            >
                <div className="hero-overlay absolute inset-0"></div>
                <div className="absolute inset-0 flex flex-col justify-center text-left px-4 sm:px-8 md:px-12 lg:pl-24 max-w-3xl">
                    <h1 className="font-playfair text-white text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-[6rem] leading-[0.9] tracking-[0.08em] sm:tracking-[0.1em] md:tracking-[0.15em] mb-4 sm:mb-6">
                        <span className="block">CASA</span>
                        <span className="block">GATCHALIAN</span>
                    </h1>
                    <div>
                        <button onClick={handleScroll} className="relative mt-2 sm:mt-4 inline-block bg-[#6b3fa0]/0 hover:bg-[#6b3fa0]/70 transition-colors px-5 sm:px-8 md:px-10 py-2.5 sm:py-3 border border-transparent font-montserrat tracking-widest text-[9px] sm:text-[10px] md:text-xs text-white after:content-[''] after:absolute after:inset-0 after:border after:border-white after:pointer-events-none active:scale-95">
                            EXPERIENCE NOW!
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
};


export default HeroSection;